import { types } from "../../Actions/types";

const initialState = {
  exercisepositionlist: [],
  error: null,
  exercisePositionSingle: "",
  popupmodel: "",
};

const ExercisePosition = (state = initialState, action) => {
  let { type, payload, error } = action;
  if (payload && payload.error !== null) {
    error = payload.error;
  }

  switch (type) {
    case types.EXERCISE_POSITION_LIST:
      return {
        ...state,
        exercisepositionlist: payload,
        error,
      };
    case types.EXERCISE_POSITION_SINGLE:
      return {
        ...state,
        exercisePositionSingle: payload,
        error,
      };
    case types.EXERCISE_POSITION_FORM_MODEL:
      return {
        ...state,
        popupmodel: payload,
      };

    default:
      return state;
  }
};

export default ExercisePosition;
